export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-3135ce88af320130a11f.worker.js");
}
